export default "__VITE_ASSET__DyA8BXza__"